import { TextInput, TextInputProps } from '@mantine/core'

export default function BlackTextInput({ classNames, ...props }: TextInputProps) {
    return (
        <TextInput
            classNames={{
                label: "black-input-label",
                input: "black-text-input-input",
                root: "black-text-input-root",
                ...classNames
            }}
            {...props}
        />
    )
}
